import { render } from "./WelcomeSection.vue?vue&type=template&id=61f76791&scoped=true"
const script = {}

import "./WelcomeSection.vue?vue&type=style&index=0&id=61f76791&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f76791"]])

export default __exports__